import * as React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../actions";
import strings from "./Localization";
import userManager from "../helpers/UserManager"; // adapte le chemin si besoin

class EnsureLoggedInContainer extends React.Component {
    state = {
        checking: true,
        isAuthenticated: false
    };

    async componentDidMount() {
        const { location } = this.props;
        const path = (location.pathname || "").toLowerCase();

        if (
            path.startsWith("/logincallback")
      || path.startsWith("/login")
        ) {
            this.setState({ checking: false, isAuthenticated: true });
            return;
        }

        try {
            await userManager.clearStaleState();
        }
        catch (e) {}

        const user = await userManager.getUser();

        if (!user || user.expired || !user.access_token) {
            await userManager.signinRedirect({
                state: location.pathname + location.search
            });
            return;
        }

        const hasCurrentUser = this.props.currentuser && this.props.currentuser.user;
        if (!hasCurrentUser) {
            await new Promise((resolve) => this.props.GetCurrentUser(resolve));
        }

        const hasConfigs = this.props.configurations != null;
        if (!hasConfigs) {
            await new Promise((resolve) => this.props.GetConfigurations(resolve));
        }

        this.setState({ checking: false, isAuthenticated: true });
    }

    render() {
        const { location, children } = this.props;
        const path = (location.pathname || "").toLowerCase();

        if (
            path.startsWith("/logincallback")
      || path.startsWith("/login")
        ) {
            return children || null;
        }

        if (this.state.checking) {
            //return <div style={{ padding: 24 }}>{strings.Loading}</div>;
            return;
        }

        if (!this.state.isAuthenticated) {
            return null;
        }

        return children;
    }
}

const mapStateToProps = (state) => state;
const mapDispatchToProps = (dispatch) => bindActionCreators(ActionsCreators, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EnsureLoggedInContainer));
